const SELECTOR = '.numbers';
const DURATION = 2000;

const easeOut = (t) => 1 - Math.pow(1 - t, 3);

document.querySelectorAll(SELECTOR).forEach((group) => {
  const numbers = [];

  group.querySelectorAll('.numbers__item span').forEach((el) => {
    const raw = el.textContent.trim();
    const match = raw.match(/-?\d+(\.\d+)?/);

    if (!match) return;

    const item = {
      el,
      target: parseFloat(match[0]),
      decimals: match[1] ? match[1].length - 1 : 0,
      prefix: raw.slice(0, match.index),
      suffix: raw.slice(match.index + match[0].length),
    };

    item.el.textContent = item.prefix + (0).toFixed(item.decimals) + item.suffix;
    numbers.push(item);
  });

  if (!numbers.length) return;

  const animate = (item) => {
    const start = performance.now();

    const step = (now) => {
      const progress = Math.min((now - start) / DURATION, 1);
      const value = item.target * easeOut(progress);
      item.el.textContent = item.prefix + value.toFixed(item.decimals) + item.suffix;

      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  };

  const run = () => numbers.forEach(animate);

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          run();
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    observer.observe(group);
  } else {
    run();
  }
});
